import React, { useState } from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'
import { Link, useNavigate  } from 'react-router-dom'
import { useAuth } from "../auth/AuthProvider";
import { apiFetch, setToken } from "../utils/api";

const SignInLayer = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({ email: "", password: "" })
    const [showPassword, setShowPassword] = useState(false)

    const showAlert = ({ type = 'info', text }) => {
        if (window.notie?.alert) {
            window.notie.alert({ type, text });
            return;
        }
        if (type === 'error') {
            console.error(text);
            return;
        }
        window.alert(text);
    };

    function validateLogin(email, password) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar email
        const minPasswordLength = 6; // Longitud mínima de la contraseña
    
        // Validar que los campos no estén vacíos
        if (!email || !password) {
            return { isValid: false, message: "Todos los campos son obligatorios." };
        }
    
        // Validar formato de email
        if (!emailRegex.test(email)) {
            return { isValid: false, message: "El formato del correo electrónico no es válido." };
        }
    
        // Validar longitud de la contraseña
        if (password.length < minPasswordLength) {
            return { isValid: false, message: `La contraseña debe tener al menos ${minPasswordLength} caracteres.` };
        }
    
        // Si todo está bien
        return { isValid: true, message: "Validación exitosa." };
    }

    const iniciarSesion = (e) => {
        e.preventDefault()
        if (validateLogin(credentials.email, credentials.password).isValid) {
            apiFetch('/api/login', {
                method: 'POST',
                body: JSON.stringify(credentials),
            })
            .then(res => {
                if(res.status && res.data?.token){
                    setToken(res.data.token);
                    localStorage.setItem('isLoggedIn', 'true');
                    showAlert({ type: 'success', text: 'Inicio de sesión exitoso' });
                    auth.setIsAuthenticated(true);
                    auth.checkAuth();
                    navigate('/sucursales');
                }
                else{
                    showAlert({ type: 'warning', text: res.message || 'Credenciales incorrectas' });
                }
            })
            .catch(() => {
                showAlert({ type: 'error', text: 'Error al iniciar sesión' });
            })
        } else {
            showAlert({ type: 'warning', text: validateLogin(credentials.email, credentials.password).message });
        }
    }

    const handleChange = (e) =>  setCredentials({ ...credentials, [e.target.name]: e.target.value });

    return (
        <section className="auth bg-base d-flex flex-wrap">
            <div className="auth-left d-lg-block d-none">
                <div className="d-flex align-items-center flex-column h-100 justify-content-center">
                    <img src="assets/images/padel_120/canchas.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
            </div>
            <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
                <div className="max-w-464-px mx-auto w-100">
                    <div>
                        <Link to="/" className="mb-40">
                            <img src="assets/images/logo.png" alt="" />
                        </Link>
                        <h4 className="mb-12">Inciar Sesión</h4>
                    </div>
                    <form action="#">
                        <div className="icon-field mb-16">
                            <span className="icon top-50 translate-middle-y">
                                <Icon icon="mage:email" />
                            </span>
                            <input
                                onChange={handleChange}
                                value={credentials.email}
                                name="email"
                                type="email"
                                className="form-control h-56-px bg-neutral-50 radius-12"
                                placeholder="Correo Electronico"
                            />
                        </div>
                        <div className="position-relative mb-20">
                            <div className="icon-field">
                                <span className="icon top-50 translate-middle-y">
                                    <Icon icon="solar:lock-password-outline" />
                                </span>
                                <input
                                    onChange={handleChange}
                                    value={credentials.password}
                                    name='password'
                                    type={showPassword ? "text" : "password"}
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    placeholder="Contraseña"
                                />
                            </div>
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                                data-toggle="#your-password"
                            />
                        </div>
                        {/* <div className="">
                            <div className="d-flex justify-content-between gap-2">
                                <div className="form-check style-check d-flex align-items-center">
                                    <input
                                        className="form-check-input border border-neutral-300"
                                        type="checkbox"
                                        defaultValue=""
                                        id="remeber"
                                    />
                                    <label className="form-check-label" htmlFor="remeber">
                                        Remember me{" "}
                                    </label>
                                </div>
                                <Link to="#" className="text-primary-600 fw-medium">
                                    Forgot Password?
                                </Link>
                            </div>
                        </div> */}
                        <button
                            onClick={iniciarSesion}
                            type="submit"
                            className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
                        >
                            {" "}
                            Sign In
                        </button>
                        
                    </form>
                </div>
            </div>
        </section>

    )
}

export default SignInLayer
